import {Component, EventEmitter, OnDestroy, Output} from '@angular/core';
import {NavController, NavParams} from "ionic-angular";

import * as $ from "jquery";
import {RoomProvider} from "../../providers/room/room";
import {FightPage} from "../../pages/fight/fight";

/**
 * Generated class for the GameRoomComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'game-room',
    templateUrl: 'game-room.html'
})
export class GameRoomComponent implements OnDestroy {

    public room: any = null;
    public user_id = null;
    public intervalConnection = null;

    @Output() onStart = new EventEmitter();

    constructor(public navCtrl: NavController,
                public navParams: NavParams,
                public roomProvider: RoomProvider) {
        console.log('Hello GameRoomComponent Component');

        this.user_id = window.localStorage.getItem('USER_ID');
        this.getRoom();

        this.intervalConnection = setInterval(() => {
            this.keepConnection();
        }, 5000);
    }

    ngOnDestroy() {
        console.log('ngOnDestroy GameRoomComponent');

        clearInterval(this.intervalConnection);
        if (this.room && parseInt(this.user_id) === parseInt(this.room.author_post_id)) {
            this.roomProvider.remove_user(this.room.id).subscribe();
        }
    }

    getRoom() {
        this.room = this.navParams.get('room');

        if (this.room && parseInt(this.user_id) !== parseInt(this.room.author_post_id)) {
            setTimeout(() => {
                $('.math-container-config > .well').addClass('is-disabled');
            }, 400);
        }
    }

    keepConnection() {
        if (!this.room) {
            return;
        }

        if (this.room && parseInt(this.user_id) === parseInt(this.room.author_post_id)) {
            return;
        }

        this.roomProvider.detail(this.room.id).subscribe((resp: any) => {
            if (!resp.status) {
                this.navCtrl.setRoot(FightPage);
                return;
            }

            if (this.room.status !== 'playing' && resp.data.status === 'playing') {
                this.onStart.emit();
            }

            this.room = resp.data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/components/game-room/game-room.ts